module.exports = __webpack_public_path__ + "img/james.400f5223.png";